import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import DefaultFullStar from 'assets/icons/RatingComponent/fullstar.svg?react';
import DefaultHalfStar from 'assets/icons/RatingComponent/halfstar.svg?react';

// TODO: TFR-44 move to container group
export const Container = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  margin-bottom: 0.3rem;
`;

// TODO: TFR-44 move to container group or do not export
export const StarsContainer = styled.div`
  margin-right: 0.2rem;
`;

// TODO: TFR-44 move to icon group
export const FullStar = styled(DefaultFullStar)`
  color: ${({ theme }) => theme.colors.yellowMedium};
  margin-right: 0.2rem;
`;

// TODO: TFR-44 move to icon group
export const HalfStar = styled(DefaultHalfStar)`
  margin-right: 0.2rem;
`;

// TODO: TFR-44 move to icon group
export const EmptyStar = styled(DefaultFullStar)`
  color: ${({ theme }) => theme.colors.yellowLight};
  margin-right: 0.2rem;
`;
